import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import { render } from "react-dom";
// import routes from './routes';
import { createBrowserHistory } from "history";
import { BrowserRouter } from "react-router-dom";

// Wait for window.env to be available before rendering React
function renderApp() {
  if (window.env && window.env.ServerUrl) {
    ReactDOM.render(<App />, document.getElementById("root"));
    registerServiceWorker();
  } else {
    // Use requestAnimationFrame for better performance than setTimeout
    requestAnimationFrame(renderApp);
  }
}

renderApp();
